import './app-promo.less';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
	intl: PropTypes.func
};

const AppPromo = ({ intl }) => (
	<div>
		<div className="app-promo propmo-border__tg">
			<h3 className="font-proxima-nova-semibold">{intl('Присоединяйся к нам в соц сетях')}</h3>
			<div className="promo-pages">
				<a className="promo-pages__item" href="https://t.me/everad_official">
					<span>{intl('Telegram группа')}</span>
				</a>
				<a className="promo-pages__item" href="https://t.me/everad_ru">
					<span>{intl('Telegram канал')}</span>
				</a>
				<a className="promo-pages__item" href="https://www.facebook.com/everadgroup/">
					<span>{intl('Страница в Facebook')}</span>
				</a>
			</div>
		</div>
	</div>
);

AppPromo.propTypes = propTypes;
export default AppPromo;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/dashboard/components/app-promo.js